import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_351: DocMigration = {
  maxSchemaVersion: "0.0.351",
  description: "Introduce legacy flag for eave frieze board extents",
  apply(json: any) {
    for (const settingsId in json.settings) {
      const setting = json.settings[settingsId];

      if (setting.type === "ROOF_SETTINGS") {
        const { eaveFriezeBoardExtents = "EAVE_AND_EAVE_RETURNS", fullReturnOrientation } = setting;

        if (eaveFriezeBoardExtents !== "EAVE_AND_EAVE_RETURNS" && fullReturnOrientation !== "NO_FACES") {
          json.settings[settingsId] = { ...setting, eaveFriezeBoardExtents: "LEGACY_EAVE" };
        }
      }
    }
    for (const id in json.roofs) {
      const { roofSettings } = json.roofs[id];

      if (!roofSettings) {
        continue;
      }

      const { eaveType, eaveFriezeBoardExtents = "EAVE_AND_EAVE_RETURNS", fullReturnOrientation } = roofSettings;

      if (
        eaveType === "BOXED_FULL_RETURN" &&
        eaveFriezeBoardExtents !== "EAVE_AND_EAVE_RETURNS" &&
        fullReturnOrientation !== "NO_FACES"
      ) {
        json.roofs[id].roofSettings = { ...roofSettings, eaveFriezeBoardExtents: "LEGACY_EAVE" };
      }
    }

    return json;
  },
};

export default migration_0_0_351;
